import { ParametersService } from 'app/shared/services/parameters/parameters.service';
import { FaiconService } from './../../../shared/services/faicon/faicon.service';
import { Parameter, ValueParameter } from './../../../shared/models/class/parameter/parameter';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { CodeClub } from 'app/shared/models/class/club/club';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { UiService } from 'app/shared/services/ui/ui.service';

export interface DialogData {
  action: string;
  parameter: Parameter;
}

type switchOptions = {
  [key: string]: any
};
@Component({
  selector: 'app-open-dialog-add-edit-parameter',
  templateUrl: './open-dialog-add-edit-parameter.component.html',
  styleUrls: ['./open-dialog-add-edit-parameter.component.scss']
})
export class OpenDialogAddEditParameterComponent implements OnInit {

  parameterForm: UntypedFormGroup;
  title: string;
  confirm = false;

  color: ThemePalette = 'primary';
  userConnected: InfosUser;
  clubCode: string;

  today = new Date();
  clubs: CodeClub[];
  btnConfirm: string;
  text: string;

  typeOfInput: string[] = ['texte', 'date', 'heure', 'valeur min/max', 'liste', 'checkbox'];

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<OpenDialogAddEditParameterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private parametersSrv: ParametersService,
    private authService: AuthService,
    private uiService: UiService,
    private route: ActivatedRoute,
    private faIconService: FaiconService
  ) {
  }

  ngOnInit(): void {
    this.initForm();
    this.initComponent();
  }

  onSubmit(): void {


    const arrayValueConvert = [];

    this.parameterForm.value.values.forEach(v => {
      for (const [key, value] of Object.entries(v)) {
        const valueConvert = new ValueParameter(key, value?.toString());
        arrayValueConvert.push(valueConvert);
      }
    });

    arrayValueConvert.forEach((v, iavc) => {
      if (!v.name.length && !v.value.length) {
        this.parameterForm.value.value.split(iavc, 1);
      }
    });

    if (this.data.action === 'edit') {
      this.parameterForm.value.type = this.data.parameter.type;
    }

    this.parameterForm.value.values = arrayValueConvert;


    const parameter = new Parameter(this.f.label.value, this.f.type.value, arrayValueConvert);


    switch (this.data.action) {
      case 'add':
        this.parametersSrv.addParameter(parameter).subscribe({
          next: () => {
            this.dialogRef.close({ data: parameter });
          },
          error: error => this.uiService.showSnackbar(error.error)
        });

        break;
      case 'edit':
        parameter.parameterKey = this.data.parameter.parameterKey;
        this.parametersSrv.updateParameter(parameter).subscribe({
          next: () => {
            this.dialogRef.close({ data: parameter });
          },
          error: error => this.uiService.showSnackbar(error.error)
        });

        break;
      default:
        break;
    }

  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private getLabel(type: string): string {
    const label: switchOptions = {
      add: {
        title: 'Ajouter un paramètre',
        confirm: 'Ajouter',
        text: 'Paramètre ajouté'
      },
      edit: {
        title: 'Éditer un paramètre',
        confirm: 'Mettre à jour',
        text: 'Paramètre mis à jour',
      },
    };
    return label[this.data.action][type];
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();

    const clubCode = {
      admin: this.route.snapshot.queryParams.clubCode,
      club: this.userConnected.club_code
    };

    this.clubCode = clubCode[this.userConnected.role];
    this.title = this.getLabel('title');
    this.btnConfirm = this.getLabel('confirm');
    this.text = this.getLabel('text');
  }

  get f() {
    return this.parameterForm.controls;
  }

  private initForm(): void {

    let parameterKey = null;
    let label = '';
    let type = '';
    let values: ValueParameter[] | string = null;

    if (this.data.parameter) {
      label = this.data.parameter.label;
      type = this.data.parameter.type;
      values = this.data.parameter.values
    }

    this.parameterForm = this.formBuilder.group({
      parameterKey: [parameterKey],
      label: [label, Validators.required],
      type: [type, Validators.required],
      values: this.formBuilder.array([])
    });

    if (this.data.action === 'edit') {
      this.addParameterItem(this.data.parameter);
    }
  }

  getselectionParametersValues(): UntypedFormArray {
    return this.parameterForm['controls'].values as UntypedFormArray;
  }


  generateControlsValue(): void {
    const value = this.parameterForm.value.type;
    this.getselectionParametersValues().clear();
    switch (value) {
      case 'valeur min/max':
        this.getselectionParametersValues().push(this.createParameterItemValueMinAndMax());
        break;
      case 'liste':
        this.getselectionParametersValues().push(this.createParameterItemValue());
        break;
      case 'checkbox':
        this.getselectionParametersValues().push(this.createParameterItemValue());
        break;

      default:
        break;
    }
  }

  private createParameterItem(parameter: Parameter, required: boolean = false): UntypedFormGroup {
    return this.formBuilder.group({
      label: [parameter?.label],
      type: [parameter?.type],
      typeInput: [parameter?.type],
      values: this.formBuilder.array([]),
      isRequired: [required]
    });
  }

  private createParameterItemValue(value?: string): UntypedFormGroup {
    return this.formBuilder.group({
      valueSelect: [value],
    });
  }

  private createParameterItemValueMinAndMax(value?: string[]): UntypedFormGroup {
    const value1 = value ? value[0] : '';
    const value2 = value ? value[1] : '';
    return this.formBuilder.group({
      min: [value1],
      max: [value2]
    });
  }

  addParameterItemValue(value?: string): void {
    this.getselectionParametersValues().push(this.createParameterItemValue(value));
  }

  deletedParameterItemValue(indexValue: number): void {
    this.getselectionParametersValues().removeAt(indexValue);
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  addParameterItem(parameter?: Parameter, index?: number): void {
    let value = [];

    if (this.data.action === 'edit') {
      value = parameter?.values ? (parameter?.values as string)?.split('#') : [];

      switch (parameter?.type) {
        case 'valeur min/max':
          this.getselectionParametersValues().push(this.createParameterItemValueMinAndMax(value));
          break;

        case 'liste':
          value?.forEach(v => {
            this.addParameterItemValue(v);
          });
          break;

        case 'checkbox':
          value?.forEach(v => {
            this.addParameterItemValue(v);
          });
          break;

        default:
          break;
      }

    }
  }


}
